import { createSlice } from '@reduxjs/toolkit'
import { sliceStateStatus } from '@/Core';

import ISliceState from '@/interface/core/ISliceState';
import IBulkMembershipStock from '@/interface/IBulkMembershipStock';

import {
  bmsIndex,
  bmsPaginate,
  bmsPaginateByRegion,
  bmsView, 
  bmsCountPending
} from './bmsActions';
import { RootState } from '../../../store';

const initialState: ISliceState<IBulkMembershipStock[] | any> & {
  selectedRegion: string | null;
  selectedYear: number | null;
  selectedStatus: string;
  pendingStocks: number | null;
  pendingRequests: number | null;
} = {
  data: [],
  status: sliceStateStatus.idle,
  selectedRegion: null,
  selectedYear: null,
  selectedStatus: 'all',
  
  pendingStocks: null,
  pendingRequests: null,
};

const bmsSlice = createSlice({
  name: 'bms',
  initialState,
  reducers: {
    resetBmsState: () => initialState,
    setSelectedRegion: (state, action) => { state.selectedRegion = action.payload; },
    setSelectedYear: (state, action) => { state.selectedYear = action.payload; },
    resetSelectedRegion: (state) => { state.selectedRegion = null; },
    resetSelectedYear: (state) => { state.selectedYear = null; },
    setSelectedStatus(state, action) { state.selectedStatus = action.payload; },
    resetSelectedStatus: (state) => { state.selectedStatus = 'all'; },
  },
  extraReducers: (builder) => {
    builder

      // Index
      .addCase(bmsIndex.pending, (state) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(bmsIndex.fulfilled, (state, action) => {
        state.status = sliceStateStatus.fulfilled;
        state.data = action.payload.data;
      })
      .addCase(bmsIndex.rejected, (state) => {
        state.status = sliceStateStatus.rejected;
      })

      // Paginate
      .addCase(bmsPaginate.pending, (state) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(bmsPaginate.fulfilled, (state, action) => {
        state.status = sliceStateStatus.fulfilled;
        state.data = action.payload.data;
      })
      .addCase(bmsPaginate.rejected, (state) => {
        state.status = sliceStateStatus.rejected;
      })

      // Paginate by Region
      .addCase(bmsPaginateByRegion.pending, (state) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(bmsPaginateByRegion.fulfilled, (state, action) => {
        state.status = sliceStateStatus.fulfilled;
        state.data = action.payload.data;
      })
      .addCase(bmsPaginateByRegion.rejected, (state) => {
        state.status = sliceStateStatus.rejected;
      })

      // View
      .addCase(bmsView.pending, (state) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(bmsView.fulfilled, (state, action) => {
        state.status = sliceStateStatus.fulfilled;
        state.data = action.payload.data;
      })
      .addCase(bmsView.rejected, (state) => {
        state.status = sliceStateStatus.rejected;
        state.selectedStock = null;
      })

      //count
      .addCase(bmsCountPending.fulfilled, (state, action) => {
        state.pendingStocks = action.payload.stocksWithPending;
        state.pendingRequests = action.payload.totalPendingRequests;
      })
  }
});

export const selectBmsPendingStocks = (state: RootState) =>  state.bms.pendingStocks ?? 0;
export const selectBmsPendingRequests = (state: RootState) =>  state.bms.pendingRequests ?? 0;

export const {
  
  resetBmsState,
  setSelectedRegion,
  setSelectedYear,
  resetSelectedRegion,
  resetSelectedYear,
  setSelectedStatus,
  resetSelectedStatus,

} = bmsSlice.actions;

export default bmsSlice.reducer;
